import type { FC } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmailsSentForOrder from "./EmailsSentForOrder";

interface Props {
  readonly orderId: string;
}

const ExpandableEmailsSentForOrder: FC<Props> = ({ orderId }) => {
  return (
    <Accordion slotProps={{ transition: { unmountOnExit: true, mountOnEnter: true } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Wysłane wiadomości email</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <EmailsSentForOrder orderId={orderId} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpandableEmailsSentForOrder;
